/**
 * Cloudinary delivery base for product and manufacturer artwork.
 *
 * The "skinlyzer" path segment is the folder these assets have always lived in,
 * shared by every app reading this database — it is not a brand statement.
 * Product images are access_mode=public and need no signature; only PIF
 * documents are authenticated.
 */
const CLOUDINARY_BASE =
  "https://res.cloudinary.com/dpxewaxo4/image/upload/skinlyzer/images";

export function productImageUrl(imageName) {
  return imageName
    ? `${CLOUDINARY_BASE}/products/${imageName}`
    : `${CLOUDINARY_BASE}/products/default.jpg`;
}

/**
 * Manufacturer.logoUrl holds a stored path, not a bare filename — every row in
 * the column looks like "images/manuf/<file>.png". Interpolating it whole
 * produced ".../images/manuf/images/manuf/<file>.png", which Cloudinary answers
 * with a 400, so every logo on the page was broken.
 *
 * Take the basename, the same way Skinlyzer's BrandsCard does.
 */
export function manufacturerLogoUrl(logoUrl) {
  if (!logoUrl) return null;
  const fileName = logoUrl.split("/").pop();
  return fileName ? `${CLOUDINARY_BASE}/manuf/${fileName}` : null;
}
